import { getBrowseStats, getDebugName, getSql } from "#skyward_browse";
import { getAllBrowseIds, getBrowseById } from "#skyward_browseList";
import { virtualDir } from "#skyward_global";
import { ModalDialogSettings, showInformationDialog } from "#skyward_modalLayer";
import { registerLoadDOMCallback } from "#skyward_window";
import { createCache } from "./skyward.base.extensions";
import { disable } from "./skyward.ui.controls";
import * as datePicker from "./skyward.ui.datePicker";
import * as dateTimePicker from "./skyward.ui.dateTimePicker";
import { toggleIgnoreElement } from "./skyward.ui.dialogFocusManager";
import { getSvg } from "./skyward.ui.svg";
import * as timePicker from "./skyward.ui.timePicker";
import { JQueryInput } from "./types";
import { Key } from "./types/skyward/svg";

const skyward = window.skyward;

registerLoadDOMCallback(init);

$(function ()
{
    let securityPathIsOpen = false;
    const pathResponses = createCache(function (pathData: Record<string, unknown>)
    {
        return $.ajax(
            {
                url: `${virtualDir}SkySys/ModulePath/Screen`,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    module: pathData.module,
                    object: pathData.object,
                    screen: pathData.screen,
                    secondaryId: pathData.secondaryId,
                    secondaryUrl: pathData.secondaryUrl,
                    secondaryLabelPrefix: pathData.secondaryLabelPrefix
                }
            });
    });

    $(document.body).on("keydown.altF3Listener" as any, function (event: KeyboardEvent)
    {
        const eventKeys = skyward.keys.getKeyNamesFromEvent(event);
        if (!eventKeys.ALT || !eventKeys.F3 || securityPathIsOpen)
        {
            return;
        }

        securityPathIsOpen = true;
        const currentPath = $("#master,.workflow.skywardContentPanel,.secondaryLocationData").last();
        const options = { beforeClose: function () { securityPathIsOpen = false; } };
        let dialogContainer: JQuery<HTMLElement>;

        const content = pathResponses(currentPath.data())
            .then(function (popupHtml)
            {
                const popup = $(popupHtml);

                if (currentPath.find(".js-fieldRestrictionMarker").length > 0)
                {
                    popup.append(createFieldRestrictionSection());
                }

                const showSqlButton = popup.data("canViewBrowseSql");
                const browseNames = getAllBrowseIds();
                const browseSections =
                    browseNames
                        .filter(function (name) { return document.getElementById(name); })
                        .map(function (name) { return createBrowseSection(name, showSqlButton); });

                return popup.append(browseSections);
            });
        dialogContainer = showInformationDialog("Security Location", content, null, options).container;

        const svgDefinition =
            "<svg xmlns='http://www.w3.org/2000/svg' class='svgNoHover datapathPopupRow__browseHighlight'>" +
            "<defs>" +
            "<mask id='cutout'>" +
            "<rect x='0' y='0' width='100%' height='100%' fill='white' />" +
            "<rect class='cutoutRect' fill='black' />" +
            "</mask>" +
            "</defs>" +
            "<rect x='0' y='0' width='100%' height='100%' fill='rgba(0,0,0,0.4)' mask='url(#cutout)' />" +
            "</svg>";
        const marker = $(new DOMParser().parseFromString(svgDefinition, "text/xml").childNodes[0]) as JQuery<HTMLElement>;
        const maskRect = marker.find(".cutoutRect");

        let currentScrollParent: JQuery<HTMLElement>;
        let scrollParentDimensions: DOMRect;

        function createFieldRestrictionSection()
        {
            const label = $("<span>", { class: "boldFont", text: "Customized Screen: " });
            const checkbox = $("<input>", { type: "checkbox", style: "margin: 0px; padding: 0px", checked: "checked" });
            const fieldRestrictionMark = $("<span>", { text: "***" });

            disable(checkbox);

            return createDataPathRow([label, checkbox, fieldRestrictionMark]);
        }

        function createBrowseSection(browseName: string, showSqlButton?: boolean)
        {
            const browseData = getBrowseById(browseName)!;
            const stats = getBrowseStats(browseName);

            const browseDebugName = getDebugName(browseData);

            let detailsURL = `${virtualDir}SkySys/Browse/Details/${browseData.browseId}`

            let browseParagraphs = [$("<p>", { addClass: "boldFont datapathPopupRow__text", text: browseDebugName })];

            if (browseData.browseId != null && (browseData.browseId as number) >= 0)
            {
                browseParagraphs.push($("<a>", { addClass: "boldFont datapathPopupRow__text", text: `ID: ${browseData.browseId}, View ID: ${browseData.viewId}`, href: detailsURL }));
            }

            if (stats !== undefined)
            {
                browseParagraphs = browseParagraphs.concat(Object.keys(stats).map(function (key)
                {
                    return $("<p>", { addClass: "datapathPopupRow__text", text: key + ": " + stats[key] + "ms" });
                }));
            }
            else
            {
                browseParagraphs.push($("<p>", { addClass: "datapathPopupRow__text", text: "No browse load times available." }));
            }

            if (showSqlButton)
            {
                const viewSqlButton = createButton("Show Query Text", "Eye").on("click", function () { showSqlPopup(browseDebugName) });
                browseParagraphs.push($("<p>", { addClass: "datapathPopupRow__text", append: viewSqlButton }));
            }

            const browseElement = browseData.browse![0];

            const section = createDataPathRow(browseParagraphs)
                .on("mouseenter", highlightBrowse)
                .on("mouseleave", endHighlight);

            return section;

            function showSqlPopup(title: string)
            {
                const sqlResult = getSql(browseName)!;
                let contents: JQuery<HTMLElement>[] | JQuery.Promise<JQuery<HTMLElement>[]>;
                if (typeof sqlResult === "string")
                {
                    contents = getContents(sqlResult);
                }
                else
                {
                    contents = sqlResult.then(function (sqlText)
                    {
                        return getContents(sqlText);
                    });
                }
                
                const dialog = showInformationDialog(title, contents);
                dialog.content.addClass("datapathPopup__browseSql");

                function getContents(sqlText: string)
                {
                    const textarea = $("<textarea>",
                        {
                            attr: { readonly: "" },
                            css: { width: "80vw", height: "60vh" },
                            text: sqlText
                        });
                    const copySqlButton = createButton("Copy Query Text", "ClipboardPencil").on("click", function () { copyText(sqlText); });
                    return [textarea, copySqlButton];
                }
            }

            function copyText(text: string)
            {
                // If we use the existing textarea, we can't clear the selection without affecting its scroll position
                const tempTextArea = $("<textarea>",
                    {
                        css: { width: 0, height: 0, position: "fixed" },
                        text: text
                    });
                tempTextArea.appendTo(document.body);
                toggleIgnoreElement(tempTextArea, true);
                tempTextArea.trigger("focus");
                tempTextArea.trigger("select");
                document.execCommand("copy");
                tempTextArea.remove();
            }

            function highlightBrowse()
            {
                const jqBrowse = $(browseElement);
                currentScrollParent = jqBrowse.closest(":scrollable");
                if (currentScrollParent.length)
                {
                    scrollParentDimensions = currentScrollParent[0].getBoundingClientRect();
                    jqBrowse.scrollintoview();
                    addMarkerScrollCallback(browseElement);
                }
                else
                {
                    scrollParentDimensions = { left: -Infinity, right: Infinity, top: -Infinity, bottom: Infinity } as DOMRect;
                }
                updateMarkerPosition(browseElement);
                dialogContainer.before(marker);
            }

            function endHighlight()
            {
                currentScrollParent.stop();
                marker.remove();
            }
        }

        function createDataPathRow(content: JQuery<HTMLElement>[])
        {
            return $("<div>",
                {
                    class: "datapathPopupRow",
                    append: content
                });
        }

        function createButton(text: string, svgName: Key)
        {
            return $("<a>",
                {
                    addClass: "button chromeless toolbarButton svgAnchor",
                    attr: { href: "#", alt: text },
                    append: [
                        getSvg(svgName),
                        $("<span>", { class: "buttonNameLabel", text: text })
                    ]
                });
        }

        function updateMarkerPosition(browseElement: HTMLElement)
        {
            const dimensions = browseElement.getBoundingClientRect();
            const left = Math.max(dimensions.left, scrollParentDimensions.left);
            const top = Math.max(dimensions.top, scrollParentDimensions.top);
            const right = Math.min(dimensions.right, scrollParentDimensions.right);
            const bottom = Math.min(dimensions.bottom, scrollParentDimensions.bottom);
            // Prevent Safari complaining about negative width/height
            maskRect.attr({ x: left, y: top, width: Math.max(right - left, 0), height: Math.max(bottom - top, 0) });
        }

        // $.scrollintoview() doesn't allow us to pass in animation callbacks, so we have to add them by hand
        function addMarkerScrollCallback(browseElement: HTMLElement)
        {
            const timer = $.timers.find(function (timer) { return timer.queue === "scrollintoview" && timer.elem === currentScrollParent[0]; });
            if (timer)
            {
                timer.anim.progress(function () { updateMarkerPosition(browseElement); });
            }
        }
    });
});

function init(selector: JQueryInput)
{
    $(selector).find(".dataObjectViewer").each(function ()
    {
        var dov = $(this);
        dov.on("keydown" as any, "input,textarea,select", altF2Listener(dov.data("module"), dov.data("object")));
    });

    $(selector).find(".workflowContent").each(function ()
    {
        const workflowContent = $(this);
        const postData = { taskInstanceID: workflowContent.data("workflow-task-instance-id") };

        if (postData.taskInstanceID == undefined)
        {
            return;
        }

        workflowContent.off("keydown.altF2Listener").on("keydown.altF2Listener" as any, "input,textarea,select", altF2Listener("Workflow", "TaskInstance", postData));
    });
}

function altF2Listener(module: string, object: string, postData?: Record<string, unknown>)
{
    return function (this: JQueryInput, event: KeyboardEvent)
    {
        const eventKeys = skyward.keys.getKeyNamesFromEvent(event);
        if (!eventKeys.ALT || !eventKeys.F2)
        {
            return;
        }

        const elem = $(this);
        const codeEELParent = elem.closest(".codeEEL");
        const dmseParent = elem.closest(".distinctMultiSelectEEL");
        const datePickerParent = elem.closest("sky-datepicker");
        const timePickerParent = elem.closest("sky-timepicker");
        const dateTimePickerParent = elem.closest("sky-datetimepicker");

        let overrideElem = elem;

        if (codeEELParent.length > 0)
        {
            overrideElem = codeEELParent;
        }
        else if (dmseParent.length > 0)
        {
            overrideElem = dmseParent;
        }
        else if (datePickerParent.length > 0)
        {
            overrideElem = datePickerParent;
        }
        else if (timePickerParent.length > 0)
        {
            overrideElem = timePickerParent;
        }
        else if (dateTimePickerParent.length > 0)
        {
            overrideElem = dateTimePickerParent;
        }
        const override =
        {
            module: overrideElem.data("datapathoverridemodule"),
            object: overrideElem.data("datapathoverrideobject"),
            field: overrideElem.data("datapathoverridefield")
        };

        let deferred;
        if (override.field)
        {
            deferred = $.Deferred().resolve(override);
        }
        else if (dmseParent.length > 0)
        {
            const dmseModule = dmseParent.data().module;
            const dmseObject = dmseParent.data().object;
            let dmseField = dmseParent.data().distinctField;
            if (dmseField == null)
            {
                dmseField = dmseObject + "ID";
            }

            const data = $.extend(
                {
                    moduleName: dmseModule,
                    objectName: dmseObject,
                    fieldName: dmseField
                }, postData);

            deferred = $.post(`${virtualDir}SkySys/F2FieldInfo/GetF2FieldInfo`, data);
        }
        else
        {
            let strippedFieldName = elem.attr("name")?.split("_")[0];
            if (elem.parent().is(".tileViewEEL"))
            {
                strippedFieldName = elem.attr("name")?.split("_")[1];
            }
            else if (datePickerParent.length > 0)
            {
                strippedFieldName = datePickerParent.attr("name")?.split("_")[0];
            }

            const data = $.extend(
                {
                    moduleName: module,
                    objectName: object,
                    fieldName: strippedFieldName
                }, postData);

            deferred = $.post(`${virtualDir}SkySys/F2FieldInfo/GetF2FieldInfo`, data);
        }

        deferred.done(function (result)
        {
            if (elem.hasClass("datepicker"))
            {
                elem.datepicker("hide");
            }
            else if (datePickerParent.length > 0)
            {
                datePicker.closeModal(datePickerParent);
            }
            else if (timePickerParent.length > 0)
            {
                timePicker.closeModal(timePickerParent);
            }
            else if (dateTimePickerParent.length > 0)
            {
                dateTimePicker.closeModal(dateTimePickerParent);
            }
            if (!result.field)
            {
                return;
            }
            const label = $(overrideElem).siblings("label.title").contents(":empty").text() || result.field;
            const data = $.extend({}, { module: module, object: object, label: label, elem: elem }, result);
            showDataPathPopup(data);
        });
    };
}

/**
 * Display a popup with the data path for a given field.
 * @param data Object holding named arguments for the popup
 */
function showDataPathPopup(data: Record<string, string>)
{
    const content = $("<div class='informationPopup'>").append(
    [
        createRow("Module", data.module),
        createRow("Object", data.object),
        createRow("Field", data.field),
        createRow("Type", data.type),
        createRow("Default Value", data.defaultValue)
    ]);
    const options: ModalDialogSettings =
    {
        anchorTo: data.elem,
        id: "dataPathPopup"
    };
    showInformationDialog(data.label + " Data Path", content, null, options);

    function createRow(name: string, value: string)
    {
        const titleSpan = $("<span class='boldFont'>").text(name + ": ");
        const valueSpan = $("<span>").text(value);
        return $("<div class='datapathPopupRow'>").append([titleSpan, valueSpan]);
    }
}